import { useEffect } from "react";

import { useThunkDispatch } from "@/redux/dispatcher";
import { CartItemModel } from "@/redux/modules/api/data/cart/@types/cart.model";
import { CTAAction } from "@/redux/modules/api/data/cart/@types/cart.types";
import * as CartModule from "@/redux/modules/api/data/cart/cart.module";

type Props = {
    sku?: string;
};

const AcceptPositiveDeliveryPromiseAction = ({ sku }: Props) => {
    const dispatch = useThunkDispatch();

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        if (sku) {
            dispatch(CartModule.acceptPositiveDeliveryPromise(sku));
        }
    }, [sku]);

    return null;
};

const acceptPositiveDeliveryPromise: CTAAction = (
    product: CartItemModel | null
) => {
    return <AcceptPositiveDeliveryPromiseAction sku={product?.sku} />;
};

export default acceptPositiveDeliveryPromise;
